import type { FaireProductEntity } from "../../entity_types/product";

export const p_7w73a83zkb: FaireProductEntity = {
  token: "p_7w73a83zkb",
  type: "product",
  name: "You Give Me Goosebumps Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/adb9e633b325e563f1e5aff5f87ef81222eb50761564dbabe42dff864d4de3d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32ae545c7d8e5a951e22f0ec98ba85e26d847240aa2210ef0848108dce3656df.jpeg",
    "https://cdn.faire.com/fastly/9175e51b767260430b48b00c4278d837e8d9ee07097ad61db393e3c88f8c5bb8.jpeg",
    "https://cdn.faire.com/fastly/d426f2c558d0ec6ad9e4894ac0052db83d31e13041afc4e001ecfd0d8534b1e0.jpeg",
    "https://cdn.faire.com/fastly/773ec1dfcd6781c0377c3abca2cef484dd87b7756e51d2a3950bbc4bdbcd68a1.jpeg",
    "https://cdn.faire.com/fastly/f88d48ebca974f4bb0b4cd9857b1e6151df4563e7e5dd1872fdd73299c64edc5.jpeg",
    "https://cdn.faire.com/fastly/9a58db16b2f901b6e7e5b913e1bfd826226b99792078e3138447cd14f5667776.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Valentine's Day Collection featuring an all-over design displaying a pattern of goose characters fist-bumping with a funny love-themed sentiment that reads \"You Give Me Goosebumps.\" Goose inspired pattern is replicated from playful hand illustrated artwork. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our You Give Me Goosebumps kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A fun love-themed gift perfect for both friends and partners on Valentine's Day or in everyday moments.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:21.998Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
